import { render, staticRenderFns } from "./SignUpLayoutBox.vue?vue&type=template&id=6e8955a0&scoped=true&"
import script from "./SignUpLayoutBox.vue?vue&type=script&lang=js&"
export * from "./SignUpLayoutBox.vue?vue&type=script&lang=js&"
import style0 from "./SignUpLayoutBox.vue?vue&type=style&index=0&id=6e8955a0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8955a0",
  null
  
)

export default component.exports